/* eslint-disable import/prefer-default-export */

export const contentBlockerHeight = 90;
